import React from "react";

import PikachuGif from "./assets/pikachu.gif";
import BIGILogo from "./assets/bigi-logo.png";
import BIGILogoWithText from "./assets/bigi-logo-text.png";
import Button from "../button";

import WithIntersectionObserver from "../../../../hocs/WithIntersectionObserver/WithIntersectionObserver";
import LottieAnimation from "../ui/lottie-animation/LottiAnimation";
import RecomandedPlan from './assets/recomanded-plan.json';

import { translate } from "react-polyglot";
import { isMobile } from 'lib/checkuseros';


import "./styles.less";


const AnimatedLottie = WithIntersectionObserver(LottieAnimation);


const BlockTypes = ({ t, registrationRedirectionURL }) => {
  const isMobileOS = isMobile()

  const handleRegistrationClick = () => {
    if (isMobileOS) {
      window.location.assign(`${window.location.origin}/redirects/checkos_redirect.html`);
      return;
    }

    window.location.assign(registrationRedirectionURL);
  };

  return (
    <div className="block-types__container">
      <div className="block-types__inner-wrapper">
        <img className="block-types__image" src={PikachuGif} alt="pikachu gif" />
        <p className="block-types__title">{t("landing.block-types.title")}</p>
        <p className="block-types__subtitle">{t("landing.block-types.subtitle")}</p>
        <div className="block-types__cards">
          <div className="block-types__card">
            <div className="block-types__card-image-container">
              <img src={BIGILogoWithText} width={110} height={41} alt="BIGI logo" className="block-types__card-image" />
              <div className="block-types__card-image-animation">
                <AnimatedLottie animationData={RecomandedPlan} />
              </div>
            </div>
            <p className="block-types__card-text">{t("landing.block-types.plus.text")}</p>
            <Button
              handleClick={handleRegistrationClick}
              text={t("landing.block-types.plus.button")}
              size="md"
              variant="filled"
            />
          </div>
          <div className="block-types__card">
            <img src={BIGILogo} width={95} height={45} alt="BIGI logo" className="block-types__card-image" />

            <p className="block-types__card-text">{t("landing.block-types.standard.text")}</p>
            <Button
              handleClick={handleRegistrationClick}
              text={t("landing.block-types.standard.button")}
              size="md"
              variant="outline"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default translate()(BlockTypes);



// WEBPACK FOOTER //
// ./src/js/components/pages/newLandingPage/block-types/index.js